import React, { Component, useEffect, useState } from 'react'
import { shallowEqual, useDispatch, useSelector } from "react-redux";
import {
  getCountry,
  getState,
  saveStepSuccess,
  handleFormStep,
  storeSavedData,
  setSavedData,
  handleSaveFormLoader,
  applicationSubmitted,
  handleFormLoader,
  handleLoggedInUser,
  handleLoggedOutUser } from '../../../store/actions/application'
import BayanAppSteps from './bayanSteps.js'
import BayanAppProgress from './bayanProgress.js'
// import './style.scss'
import { getSavedAppData, getSavedAppDataForAppId } from '../../../api/application.js';
import Store from '../../../store';
import BeginningScreen from './beginningScreen.js';
import Review from './review.js';
import { saveFormStep, saveBayanApplication } from '../../../api/application'
import { getAllPrograms } from '../../../api/register';
import { TelegramIcon } from 'react-share';

function BayanApplication(props) {
  const dispatch = useDispatch();
  const [state, setState] = useState({
    showBeginApp: true,
    reviewApplication: false
  })
  const [programs, setPrograms] = useState([]);
  const { userAuth } = Store.getState();
  const { bayanStep, savedSteps, bayanProgress, userId, loggedOutUserEmail } = useSelector((state) => ({
		bayanStep: state.applicationReducer.bayanStep,
		savedSteps: state.applicationReducer.savedSteps,
    bayanProgress: state.applicationReducer.bayanProgress,
    userId: state.applicationReducer.userId,
    loggedOutUserEmail: state.applicationReducer.loggedOutUserEmail,
  }), shallowEqual);

    useEffect(() => {
      getAllPrograms().then(res => {
        if (res && Object.keys(res).length) {
          const programs = res.data.filter((item) => item.description).map(filteredItem => {
            return { id: filteredItem.id, label: filteredItem.title, value: filteredItem.title.replace(/ /g, "_").toLowerCase(), description: filteredItem.description || '' };
          });
          // console.log(programs);
          setPrograms(programs)
        }
      })
    }, []);

    useEffect(() => {
      const { router } = props;
      dispatch(setSavedData({}))
      if (!!router.query.appid) {
        let appId = router.query.appid;
        getSavedAppDataForAppId(appId).then(response =>{
          if(response && response.data) {
            if(response.data.email && response.data.user_id == 0){
              dispatch(handleLoggedOutUser(response.data.email));
            } else if(response.data.email && response.data.user_id !== 0) {
              dispatch(handleLoggedInUser(response.data.user_id));
            }
          }
          if(response && response.status === 'success' && response.data) {
            if (response?.data?.loggedOutUserInfo?.email && response?.data?.loggedOutUserInfo?.program_id) {
              dispatch(setSavedData(response.data));
              setState({ ...state, showBeginApp: false, reviewApplication: true});
            } else {
              dispatch(setSavedData(response.data));
              setState({ ...state, showBeginApp: false, reviewApplication: false});
              dispatch(handleFormStep('loggedOutUserInfo'));
            }
          } else {
            (dispatch(setSavedData({})), setState({ ...state, showBeginApp: true, reviewApplication: false}));
          }
        })
      } else if(userAuth && userAuth.userId != null) {
        dispatch(handleLoggedInUser(userAuth.userId));
        getSavedAppData({user_id: userId}).then(response =>{
          response && response.status === 'success' && response.data ?
          (dispatch(setSavedData(response.data)), handleAppBeginning()) :
          (dispatch(setSavedData({})), setState({ ...state, showBeginApp: true, reviewApplication: false}));
        })
      }

    }, [props.router.query.appid]);

    const handleAppBeginningClicked = (userEmail) => {
      if(userEmail && userEmail !== null || userEmail !== '') {
        dispatch(handleLoggedOutUser(userEmail));
        getSavedAppData({email:userEmail}).then(response =>{
          response && response.status === 'success' && response.data ?
          (dispatch(setSavedData(response.data)), handleAppBeginning()) :
          handleAppBeginning();
          })
      } else {
        dispatch(setSavedData({}));
        handleAppBeginning();
      }
    }
    const handleAppBeginning = () => {
      setState({...state, showBeginApp : false, reviewApplication: false})
    }

    const handleReviewClose = () => {
      setState({...state, reviewApplication : false})
    }

    const handleReviewOpen = () => {
      setState({...state, reviewApplication : true})
    }

    return(
    <div className="application-content">
      <div className="wrapper-md">
        <div id='new-bayan-application'>
          <div className="row application-wrapper">
            <div className="column large-8">
                  {((userAuth && userAuth.appId === '') || (state.showBeginApp && !state.reviewApplication)) && <BeginningScreen user={userAuth}  startApplication={handleAppBeginningClicked} programs={programs} />}
                  {!state.showBeginApp && !state.reviewApplication && <BayanAppSteps bayanStep={bayanStep} programs={programs} /> }
                  {(!state.showBeginApp && state.reviewApplication) && <Review closeReview={handleReviewClose} fromLanding={true} /> }

            </div>

              <div className="column large-4">
                {
                  <BayanAppProgress
                    savedSteps={savedSteps}
                    bayanProgress={bayanProgress}
                    isReviewOpen={state.reviewApplication}
                    openReview={handleReviewOpen}
                    closeReview={handleReviewClose}
                    programs={programs}
                  />
                }
                {/* {<BayanChat/>} */}
              </div>
          </div>
        </div>
        </div>
    </div>
    );
}


export default BayanApplication;

